module.exports = __webpack_public_path__ + "static/img/gonganwangbei.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gonganwangbei.png
// module id = bLgo
// module chunks = 1